import api from './api';

// A request is addressed two ways, and the split is the server's: the
// collection hangs off its listing (server/src/api/listing/index.js) because
// that is what authorises reading it, while every action addressed by request
// id lives under /requests (server/src/api/request/index.js). Collapsing the
// two onto one prefix reaches routes that do not exist.
export const requestService = {
    async create(listingId, body) {
        const response = await api.post(
            `/listings/${listingId}/requests`,
            body
        );
        return response.data;
    },
    async listForListing(listingId) {
        const response = await api.get(`/listings/${listingId}/requests`);
        return response.data;
    },
    // Every request in the exchange, for the admin triage tab. The route is
    // admin-only, so a member reaching it gets a refusal rather than a
    // partial answer; `mine` is the member's own list.
    async list(params = {}) {
        const response = await api.get('/requests', { params });
        return response.data;
    },
    async mine() {
        const response = await api.get('/requests/mine');
        return response.data;
    },
    async get(id) {
        const response = await api.get(`/requests/${id}`);
        return response.data;
    },
    async accept(id) {
        const response = await api.post(`/requests/${id}/accept`);
        return response.data;
    },
    async decline(id) {
        const response = await api.post(`/requests/${id}/decline`);
        return response.data;
    },
    async withdraw(id) {
        const response = await api.post(`/requests/${id}/withdraw`);
        return response.data;
    },
    async addMessage(id, body) {
        const response = await api.post(`/requests/${id}/messages`, { body });
        return response.data;
    },
};

export default requestService;
